module.exports = __webpack_public_path__ + "img/icon_pass.42eb8951.png";